import { useEffect } from 'react';

import { handleOnMount } from '../logic';

const useErrorComponent = () => {
  useEffect(() => handleOnMount());
};

export default useErrorComponent;
